import Vue from 'vue'
import {Modal as Template} from './4trend/Modal'
import {EVENT_HIDDEN} from './Bootstrap/Modal'
import $ from 'jquery'

/**
 *
 * @param {HTMLElement} context
 */
function reapplyScripts(context) {
    const scripts = context.querySelectorAll('script');

    for (const script of scripts) {
        const newScript = document.createElement('script');
        const {parentElement} = script;

        newScript.innerHTML = script.innerHTML;
        parentElement.removeChild(script);
        parentElement.appendChild(newScript);
    }

    return context;
}

/**
 *
 * @param {HTMLElement} context
 * @param {string} html
 */
function replaceContent(context, html) {
    $(context).empty();
    context.insertAdjacentHTML('afterbegin', html);

    return context;
}

function getData(url) {
    return fetch(url).then(data => data.text())
}

export const ModalAjax = Vue.extend({
    data: () => ({
        title: '',
        contentUrl: '/test.html',
        buttons: []
    }),
    mounted() {
        const {content: contentElem, modal: modalInstance} = this.$refs;

        const loadData = () => getData(this.contentUrl)
            .then((html) => {
                replaceContent(contentElem, html);
                reapplyScripts(contentElem);
            });

        // Initial load

        loadData().then(() => this.$nextTick(() => {
            document.body.appendChild(this.$el);
            modalInstance.show();
        }));

        this.$watch('contentUrl', loadData);

        $(modalInstance.$el).on(EVENT_HIDDEN, () => this.$destroy());
    },
    destroyed() {
        this.$el.parentElement.removeChild(this.$el);
    },
    render: function (h) {
        return (
            <Template class="ft-modal-ajax" ref="modal" title={this.title}>
                <div class="overflow-hidden" ref="content"></div>
                {this.buttons}
            </Template>
        )
    }
})
